import React from "react";
import { CiLogout } from "react-icons/ci";

interface HeaderProps {
  title?: string | null;
  onLogout?: () => void;
}

const LogoutIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export const Header: React.FC<HeaderProps> = ({
  title = null,
  onLogout = null,
}) => {
  return (
    <div className="border-b px-4 py-3">
      <div className={`flex items-center justify-between w-full`}>
        <div className="flex items-center">
          <div className="flex items-center">
            <img src="assets\logo-filled.png" alt="truApp" className="h-8 w-19" />
          </div>

          <div className={`flex items-center px-3 `}>
            <h1 className="text-lg font-semibold text-gray-700"> {title} </h1>
          </div>
        </div>

        {onLogout && (
          <button
            type="button"
            aria-label="logout"
            title="Logout"
            id="logout-button"
            onClick={onLogout}
            className="text-md border border-[#33ccbf]-50 text-[#33ccbf] font-bold px-1 py-1 rounded-lg hover:bg-[#e5f0fb] transition-colors flex-shrink-0"
          >
            <CiLogout />
          </button>
        )}



        {!onLogout &&  <div className="flex items-center"></div>}
      </div>
    </div>
  );
};
